import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import app from '@/app';

const isDevEnv = process.env.NODE_ENV === 'development';
const isTestEnv = process.env.NODE_ENV === 'test';

// execute only in beta/production env
if (!isDevEnv && !isTestEnv) {
  const appVersion = import.meta.env.VUE_APP_VERSION;
  const bugsnagApiKey = import.meta.env.VUE_APP_BUGSNAG_API_KEY;

  if (bugsnagApiKey) {
    const bugsnagReportStage = import.meta.env.VUE_APP_BUGSNAG_REPORT_STAGE;
    const releaseStage = bugsnagReportStage !== undefined
      ? bugsnagReportStage
      : process.env.NODE_ENV;

    Bugsnag.start({
      apiKey: bugsnagApiKey,
      appVersion,
      releaseStage,
      plugins: [new BugsnagPluginVue()],
      onError(event) {
        const userRole = JSON.parse(localStorage.getItem('pepper_business'))?.auth.role.slug ?? 'not logged in';
        event.addMetadata('user', { role: userRole });
      },
    });

    app.use(Bugsnag.getPlugin('vue'));
  }
}

export default Bugsnag;
